import ScalarIconGavel_vue_vue_type_script_setup_true_lang_default from "./ScalarIconGavel.vue.script.js";
//#region src/components/ScalarIconGavel.vue
var ScalarIconGavel_default = ScalarIconGavel_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconGavel_default as default };

//# sourceMappingURL=ScalarIconGavel.js.map